<template id="">
  <div class="">
    <div class="loading-screen" v-if="isLoading == true">
      <h2>Loading in PDF</h2>
      <div class="spinner-wrap">
        <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate" class="md-accent"></md-progress-spinner>
      </div>
    </div>
    <div class="loading-screen">
      <h2>No Report exists at this link, please contact the person you sent you the link to this report.</h2>
    </div>
  </div>

</template>
<script type="text/javascript">
  import api from '@/api';
  export default {
    data(){
      return {
        isLoading: true,
        noReport: false,
      }
    },
    created(){
      api.getPDFLink(this.$route.params.id).then((response) => {
        console.log(response);
        //not sure if this will work in production
        var full_url = response.config.baseURL + response.config.url
        window.open(full_url, "_self");
      }).catch((e) => {
        console.log(e.response.status)
        if (e.response.status == 404){
          this.isLoading = false;
          this.noReport = true;
        } else if (e.response.status == 401){
          this.$store
            .dispatch("signOut", {})
            .then(() => {
              this.$router.push('/portallogin')
            })
        }
      })
    }
  }
</script>
